import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MapPin, Award } from 'lucide-react';
import { Waves } from './Waves';
export function Contact() {
  return <section id="contact" className="relative py-32 bg-ocean-900 overflow-hidden" data-id="element-16">
      {/* Top Waves transitioning from Gallery (gray-50) */}
      <div className="absolute top-0 left-0 w-full rotate-180 z-10" data-id="element-17">
        <Waves fill="fill-gray-50" data-id="element-18" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-ocean-800 to-ocean-900 z-0" data-id="element-19"></div>

      <div className="relative z-20 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center mt-12" data-id="element-20">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-ocean-800/80 border border-ocean-400/30 px-4 py-2 rounded-full text-sun-400 font-semibold mb-8" data-id="element-21">
          <Award size={18} data-id="element-22" />
          <span data-id="element-23">Free Estimates Available</span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-24">
          Ready to Restore Your Deck?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl text-ocean-100 mb-12 max-w-2xl mx-auto" data-id="element-25">
          Contact us today to schedule your free estimate and discover the
          difference BWC can make for your boat.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-26">
          <a href="tel:9542751630" className="flex items-center gap-3 bg-sun-500 hover:bg-sun-400 text-ocean-900 px-8 py-4 rounded-full font-bold text-xl transition-all transform hover:-translate-y-1 shadow-xl shadow-sun-500/20 w-full sm:w-auto justify-center" data-id="element-27">
            <Phone size={24} data-id="element-28" />
            <span data-id="element-29">(954) 275-1630</span>
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="mt-12 flex items-center justify-center gap-2 text-ocean-200" data-id="element-30">
          <MapPin size={20} className="text-sun-400" data-id="element-31" />
          <p data-id="element-32">Serving Miami • Broward • Palm Beach • Monroe</p>
        </motion.div>
      </div>
    </section>;
}